import { useCreation, useRequest } from 'ahooks'

import { queryAuctionDetailApi } from '@eastcoal/api/trade/auctionOperation/queryAuctionDetail'
import {
  AuctionForm,
  AuctionMemberGroupEntity,
  QuotaEntity
} from '@eastcoal/api/trade/interface'

import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'
import { omit } from '@eastcoal/common/utils/object'

export const useCopyAuctionForm = (initialValues: Partial<AuctionForm>) => {
  const { id } = useUrlParams()

  const { data, error, loading, refreshAsync } = useRequest(
    () => queryAuctionDetailApi({ id }),
    {
      manual: false,
      ready: !!id
    }
  )

  return {
    error,
    loading,
    refreshAsync,
    data: useCreation(
      () =>
        data
          ? {
              ...initialValues,
              ...omit(data, [
                'id',
                'title',
                'announcementId',
                'announcementTitle',
                'startTime',
                'endTime'
              ]),
              quotaEntities: data.quotaEntities?.length
                ? data.quotaEntities.map((item: QuotaEntity) =>
                    omit(item, ['id', 'bizId'])
                  )
                : [],
              memberGroups: data.memberGroups?.length
                ? data.memberGroups.map((item: AuctionMemberGroupEntity) =>
                    omit(item, ['id'])
                  )
                : []
            }
          : initialValues,
      [data, initialValues]
    )
  }
}
